import React, {useMemo} from 'react';
import {Flex} from "antd";
import Title from "antd/es/typography/Title";
import {t} from "i18next";
import {Brief, DataTotal} from "../../../api/types";
import SummaryItem from "./SummaryItem";

interface SummaryProps {
  brief: Brief,
  dataTotals: DataTotal[],
  selectedPlanId: number,
  historicData: DataTotal | undefined,
  showFactTotal: boolean,
}

export interface SummaryData {
  name: string,
  budget: number,
  cac: number,
  kpi: number,
  kpi_long_term: string,
  kpi_short_term: string,
  cumulative: number,
  roas: number,
  accepted: boolean,
}

export default function Summary({dataTotals, selectedPlanId, historicData, showFactTotal, brief}: SummaryProps) {
  const isCurrentPlanAccepted = (planId: number) => {
    return planId === selectedPlanId
  };

  const items = useMemo(() => {
    const data: SummaryData[] = [];

    if (historicData && showFactTotal) {
      data.push({
        name: historicData?.name || '',
        budget: historicData?.metrics?.total?.budget || 0,
        cac: historicData?.metrics?.total?.cac || 0,
        kpi: historicData?.metrics?.total?.kpi || 0,
        kpi_long_term: historicData?.metrics?.total?.kpi_long_term ? String(historicData?.metrics?.total?.kpi_long_term) : '-',
        kpi_short_term: historicData?.metrics?.total?.kpi_short_term ? String(historicData?.metrics?.total?.kpi_short_term) : '-',
        cumulative: historicData?.metrics?.total?.cumulative,
        roas: historicData?.metrics?.total?.roas || 0,
        accepted: false,
      })
    }

    for (let dataTotal of dataTotals) {
      data.push({
        name: dataTotal.name,
        accepted: isCurrentPlanAccepted(dataTotal.id),
        budget: dataTotal.metrics?.total?.budget || 0,
        cac: dataTotal.metrics?.total?.cac || 0,
        kpi: dataTotal.metrics?.total?.kpi || 0,
        kpi_long_term: dataTotal.metrics?.total?.kpi_long_term ? String(dataTotal.metrics?.total?.kpi_long_term) : '-',
        kpi_short_term: dataTotal.metrics?.total?.kpi_short_term ? String(dataTotal.metrics?.total?.kpi_short_term) : '-',
        cumulative: dataTotal.metrics?.total?.cumulative,
        roas: dataTotal.metrics?.total?.roas || 0,
      })
    }

    return data
  }, [dataTotals, historicData, selectedPlanId, showFactTotal])

  return (
    <Flex vertical gap={'middle'}>
      <Title level={4} className={'planner__block-title'}>{t('planner.summary')}</Title>
      <Flex className={'summary'} vertical gap={14}>
        {items.map((item: SummaryData) => (
          <React.Fragment key={item.name}>
            <span className={'summary__block-title'}>
              <span className={'summary__block-title__name'}>{item.name} </span>
            </span>
            <Flex className={'summary__items ' + (item.accepted ? 'summary__items--accepted' : '')} justify={'space-between'}>
              <SummaryItem label={t('planner.kpiShortTerm')}
                           value={item.kpi_short_term}/>
              <SummaryItem label={t('planner.kpiLongTerm')}
                           value={item.kpi_long_term}/>
              <SummaryItem label={t('planner.kpiInTotals')}
                           value={item.kpi}/>
              <SummaryItem label={t('planner.cumulative')}
                           value={item.cumulative}/>
              <SummaryItem label={t('planner.budgetInRubles')}
                           value={item.budget}/>
              <SummaryItem label={t('planner.roas')}
                           value={item.roas} precision={1}/>
              {/*<SummaryItem label={t('planner.cac')}
                           value={item.cac}/>*/}
            </Flex>
          </React.Fragment>
        ))}
      </Flex>
    </Flex>
  )
}
